import React from 'react';
import { Link } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';

// GraphQL: Get download CV file
const GET_WEBSITE_OPTIONS = gql`
  query GetWebsiteOptions {
    websiteOptions {
      nodes {
        websiteOptions {
          dow {
            node {
              mediaItemUrl
            }
          }
        }
      }
    }
  }
`;

// GraphQL: Get all footer menu items
const GET_FOOTER_MENU_ITEMS = gql`
  query GetFooterNavBarMenu {
    footerNavBarMenus {
      nodes {
        title
        menuItems {
          url
          order
        }
      }
    }
  }
`;

const Footer = () => {
  // Fetching website options (for CV download)
  const { data: optionsData } = useQuery(GET_WEBSITE_OPTIONS);
  // Fetching footer menu items
  const { data: menuData } = useQuery(GET_FOOTER_MENU_ITEMS);

  // CV download file URL
  const cvUrl =
    optionsData?.websiteOptions?.nodes?.[0]?.websiteOptions?.dow?.node?.mediaItemUrl ||
    '/files/naveedahmedawancv.pdf'; // Fallback if no URL is provided

  // Get and sort all footer menu items based on 'order' field
  const footerLinks =
    menuData?.footerNavBarMenus?.nodes
      ?.map(item => ({
        title: item.title,
        url: item.menuItems?.url || '#', // Ensure a fallback if URL is missing
        order: item.menuItems?.order || 0, // Ensure a fallback for order
      }))
      .sort((a, b) => a.order - b.order) || []; // Sort by order

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Smooth scroll
    });
  };

  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-6xl mx-auto text-center">
        <p className="text-gray-400">&copy; 2025 My Website. All rights reserved.</p>

        {/* Footer links and download CV */}
        <div className="mt-4 flex justify-center items-center space-x-6 flex-wrap">
          {/* Map through and display all footer menu items */}
          {footerLinks.map((item, index) => (
            <Link
              key={index}
              to={item.url}
              className="text-white hover:text-gray-300"
            >
              {item.title}
            </Link>
          ))}

          {/* Download CV Button */}
          <a
            href={cvUrl}  // Link to CV file
            download
            className="flex items-center text-white bg-[#213343] py-2 px-6 hover:bg-[#1b2b34] transition-all duration-300 ease-in-out"
          >
            Download CV
            <img
              src="/images/rightarrow.png"
              alt="Arrow"
              className="ml-2 max-w-[24px] max-h-[24px]"
            />
          </a>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <div
        onClick={scrollToTop} // Trigger scrollToTop function on click
        className="fixed bottom-8 right-8 bg-white text-black p-3 rounded-full shadow-lg cursor-pointer hover:bg-gray-200 transition-all duration-300 ease-in-out"
      >
        <img
          src="/images/navigationarrows.png" // Path to your top arrow image
          alt="Top Arrow"
          className="w-8 h-8 transform rotate-[-90deg]" // Rotate the arrow to point upwards
        />
      </div>
    </footer>
  );
};

export default Footer;
